// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxSectionItem_container__1A-kp","textRight":"BoxSectionItem_textRight__1NbHl"};